/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { VariationBadge } from 'cio/models/action';
import { SplitMetric } from 'cio/utils/metrics/models/split-metric';

interface CampaignSplitResultsTableArgs {
  availableMeasures: { key: string; title: string }[];
  originalMetric: SplitMetric;
  variationMetrics: {
    metric: SplitMetric;
    badge: VariationBadge;
  };
}

export default class CampaignSplitResultsTable extends Component<CampaignSplitResultsTableArgs> {}
